import { getQuery } from "../../search/domains/filters/selectors/getAllAppliedRefinements";
import isFacetedNavPageHelper from "../../../../helpers/isFacetedNavPage";

const isFacetedNavPage = state => {
  const { category } = state;
  if (!category) {
    return false;
  }

  const seoImportantFacets = category.details?.seoImportantFacets;
  const { refine } = getQuery(state);

  return isFacetedNavPageHelper({ seoImportantFacets, refine });
};

export default isFacetedNavPage;
